import { Injectable } from '@angular/core';
import { UserMessageRepositoryModule } from './user-message.module';
import { HttpRequestBuilder, HttpRequestMethod } from '../../core';
import { ObjectUtils, OneHttpClientService } from '../public_api';
import { Observable } from 'rxjs';
import { UserMessageSearchQuery } from './models/user-message-search-query.model';
import { UserMessage } from './models/user-message.model';

@Injectable({ providedIn: UserMessageRepositoryModule })
export class UserMessageRepository {
  public static readonly RESOURCE = {
    root: '/v1/user-message',
  };

  private _req = new HttpRequestBuilder(UserMessageRepository.RESOURCE.root);

  constructor(private http: OneHttpClientService) {}

  getMessageThread(
    query: UserMessageSearchQuery
  ): Observable<UserMessage[]> {
    const request = this._req
      .api()
      .query('rootObjectId', query.rootObjectId!)
      .query('rootObjectType', query.rootObjectType!)
      .authenticated();

    return this.http.callObject<UserMessage[]>(request);
  }

  sendMessage(message: UserMessage): Observable<any> {
    const request = this._req
      .api()
      .method(HttpRequestMethod.POST)
      .body(message);

    return ObjectUtils.CreateObjectRequestWithLocation(this.http, request);
  }
}
